import React from "react";
import { withTranslation } from "react-i18next";
import Modal from "../modal";

class VideoRecordTutorialModal extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { t } = this.props;

    return (
      <Modal width="800px">
        <div className="head">{t("videoRecordTutorial.title")}</div>
        <div className="body welcome video-record-modal">
          <a
            href="https://youtu.be/ZLVZAEQOSCk"
            target="_blank"
            rel="noopener noreferrer"
            className="button"
          >
            <img src="/img/svg/play.svg" alt="play" className="icon-white" />
            {t("videoRecordTutorial.play")}
          </a>
          <p>{t("videoRecordTutorial.intro")}</p>
          <p>{t("videoRecordTutorial.howItWorks")}</p>

          <ul>
            <li>{t("videoRecordTutorial.step1")}</li>
            <li>{t("videoRecordTutorial.step2")}</li>
            <li>{t("videoRecordTutorial.step3")}</li>
            <li>{t("videoRecordTutorial.step4")}</li>
            <li>{t("videoRecordTutorial.step5")}</li>
            <li>{t("videoRecordTutorial.step6")}</li>
            <li>{t("videoRecordTutorial.step7")}</li>
            <li>{t("videoRecordTutorial.step8")}</li>
          </ul>

          <p>{t("videoRecordTutorial.loomNote")}</p>

          <p>{t("videoRecordTutorial.browserCompatibility")}</p>

          <ul>
            <li>{t("videoRecordTutorial.chrome")}</li>
            <li>{t("videoRecordTutorial.edge")}</li>
            <li>{t("videoRecordTutorial.brave")}</li>
          </ul>

          <p>{t("videoRecordTutorial.comingSoon")}</p>

          <ul>
            <li>{t("videoRecordTutorial.firefox")}</li>
            <li>{t("videoRecordTutorial.safari")}</li>
          </ul>

          <p>{t("videoRecordTutorial.incognitoNote")}</p>

          <p>{t("videoRecordTutorial.drawingToolNote")}</p>
        </div>
      </Modal>
    );
  }
}

export default withTranslation("coaching-portal")(VideoRecordTutorialModal);
